import { getAnalytics, logEvent } from "firebase/analytics";
const analytics = getAnalytics();

export default function () {
  const logClickEvent = (elementClicked) => {
    logEvent(analytics, "click", { name: elementClicked });
  };

  return {
    logClickEvent,
  };
}
